import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface IOrderArriveWidgetProps {
    onClose: () => void;
}

export const OrderArriveWidget = ({ onClose }: IOrderArriveWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt;
                    <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="View_an_orders_expected"
                        defaultMessage="View an Order’s Expected Ship Date"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Step_by_step_guide"
                                defaultMessage="Step by Step Guide"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="On_the_eStore_home_page"
                                    defaultMessage="Step 1. On the eStore home page, click on ‘My Orders’ under ‘Quick Links’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Search_for_the_order_you_are_looking"
                                    defaultMessage="Step 2. Search for the order you are looking for and click on ‘See Details’"
                                />
                                <ul className="ordered-list-sec">
                                    <li>
                                        <FormattedMessage
                                            id="If_the_order_is_a_custom_product"
                                            defaultMessage="If the order is a custom product, earmold, or a repair order:"
                                        />
                                        <br />
                                        <FormattedMessage
                                            id="There_will_be_expected_ship_date_listed"
                                            defaultMessage="There will be an Expected Ship Date listed at the top right of the webpage, above the order tracking bar. If an order has just been placed, please allow time for the Estimated Ship Date to update."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage
                                            id="If_the_order_is_a_standard_product"
                                            defaultMessage="If the order is a standard product or miscellaneous order:"
                                        />
                                        <br />
                                        <FormattedMessage
                                            id="There_will_be_no_date_listed"
                                            defaultMessage="There will be no date listed. Expected Ship Date is not available for these order types at this time."
                                        />
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Video_tutorial"
                                defaultMessage="Video Tutorial"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="How_to_view_the_expected"
                                    defaultMessage="How to view the expected ship date"
                                />
                                <iframe
                                    className="help-center-video"
                                    src="https://bcove.video/357OTRa"
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                    title="video"
                                />
                                <FormattedMessage
                                    id="Learn_how_to_view_your_order"
                                    defaultMessage="Learn how to view your order's expected ship date"
                                />
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const orderArriveContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderArriveWidget);

export default orderArriveContainer;
